import React, {useRef, useState} from "react";
import {Button, Card, Divider, Typography, Input, OutlinedInput} from "@mui/material";
import {CardBody, Col, Modal, Row} from "react-bootstrap";
import {Label} from "@mui/icons-material";

const Section = ({id, bg = "light", title, subtitle, children}) => (
    <section id={id} className={`py-5 bg-${bg}`}>
        <div className="container">
            <Typography variant="h4" className="mb-4 text-center fw-bold">{title}</Typography>
            <Typography variant="h5" className="mb-4 text-center">{subtitle}</Typography>
            {children}
        </div>
    </section>
);


const Home = () => {

    const [showFormModal, setShowFormModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(false);
    const [imageUrl, setImageUrl] = useState(null);
    const [imageDesc, setImageDesc] = useState(null);
    const [imageTitle, setImageTitle] = useState(null);
    const [showMore, setShowMore] = useState(false);
    const [showMoreReports, setShowMoreReports] = useState(false);

    const [name, setName] = useState();
    const [psbRef, setPsbRef] = useState("psb0-899-plug");
    const [email, setEmail] = useState();
    const [phone, setPhone] = useState();
    const [website, setWebsite] = useState();
    const [softwares, setSoftwares] = useState();
    const [contactTime, setContactTime] = useState();
    const [formResponse, setFormResponse] = useState();
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true);
        const jsonData = {
            name: name,
            email: email,
            phone: phone,
            website: website,
            software: softwares,
            contactTime: contactTime,
            psbRef: psbRef
        }

        const formUrl = 'https://app.playspacebrain.com/app/contact';

        fetch(formUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(jsonData)
        })
            .then(response => {
                if (response.ok) {
                    setFormResponse('Thank you for your inquiry. We will be in touch shortly!');
                } else {
                    console.error('Error submitting data:', response.status);
                }
            })
            .catch(error => {
                console.error('Error during request:', error);
            });
    }

    return (
        <>

            {/* Hero Section */}
            <div style={{
                width: '100%',
                height: 'auto',
                backgroundImage: "url('https://playspacebrain.com/images/bubble-time.d6eec82a72e5459c3a84.png')",
                backgroundRepeat: 'no-repeat',
                // backgroundPosition: "right -500px top 25%",
                backgroundSize: "cover",
                borderBottom: 'solid 10px #111',
            }}>
                <div style={{
                    background: 'rgba(255,255,235,0.8)',
                    width: '100%',
                    height: 'auto'
                }}>
                    <Section id="home" bg="none" title="">
                        <div className="row align-items-center">
                            <div className="col-md-4 text-center">
                                <img alt={'Play Space Brain Header Logo - Big 2025!'}
                                     src={'https://playspacebrain.com/images/psb-logo-round-full.png'} style={{
                                    width: '55%',
                                    height: 'auto',
                                }}/>
                            </div>
                            <div className="col-md-8 hero">
                                <h1 className="fw-bold mb-3">
                                    Client Focused Play Space Management Software
                                    <span style={{
                                        fontSize: '24px',
                                        lineHeight: '1',
                                        letterSpacing: '0rem',
                                        display: 'block'
                                    }}>All in one software solution for indoor play spaces</span>
                                </h1>
                                <hr style={{
                                    margin: '20px 0',
                                    borderBottom: "solid 2px #EBD204"
                                }}/>

                                <h3>Exclusively built for indoor play spaces, easy for your team to use, and designed to
                                    build lasting relationships with every customer!
                                </h3>

                                <p className={'mt-3'} style={{
                                    textAlign: 'justify'
                                }}><b>Remember every detail</b>. Our software helps your team deliver the kind of
                                    personal care that keeps families loyal by remembering client details, preferences,
                                    and history, so every visit feels personal.
                                </p>

                                <Button variant="contained" color="primary" size="large" className="mt-3"
                                        onClick={() => {
                                            setShowFormModal(true);
                                        }}>
                                    Join our Pilot Program
                                </Button>
                                <Divider sx={{
                                    margin: '40px 0'
                                }}/>
                                <div className="col-md-12  text-center">

                                    {/*<Avatar className={' mx-2'}*/}
                                    {/*        sx={{*/}
                                    {/*            width:'90%',*/}
                                    {/*            height: 'auto',*/}
                                    {/*            background:"#fff",*/}
                                    {/*            margin:'20px',*/}
                                    {/*            boxShadow: '0 0 10px #ddd',*/}
                                    {/*            border: 'solid 1px #fff',*/}
                                    {/*            borderRadius: '15px'*/}
                                    {/*        }}*/}
                                    {/*        variant="rounded">*/}
                                    {/*    <img src={'../src/static/media/bubble-time.d6eec82a72e5459c3a84.png'}*/}
                                    {/*         style={{*/}
                                    {/*             width: '100%',*/}
                                    {/*             height: 'auto',*/}
                                    {/*         }}/>*/}
                                    {/*</Avatar>*/}

                                </div>
                            </div>

                        </div>
                    </Section>
                </div>
            </div>
            {/* About Section */}

            <Section id="inside" bg="white" title="All in One Software Solution for Indoor Play Spaces"
                     subtitle="Powerful features designed to save time, reduce stress, and help your business grow">
                <div className="row">
                    <div className={'col-md-6'}>
                        <h5>Built by play space owners for play space owners</h5>

                        <img src="https://playspacebrain.com/images/psb-feature-13.png" alt="About"
                             className="img-fluid rounded shadow"/>

                        <p className={'mt-3'}>
                            Play Space Brain streamlines your daily
                            operations with purposefully built management tools designed specifically for indoor play
                            spaces.
                        </p>
                        <p>
                            Easily manage your customers, classes, camps, events, parties, store, and staff, all in one
                            place.
                        </p>

                    </div>
                    <div className="col-md-6 d-flex flex-column justify-content">

                        <div style={{
                            fontSize: "0.9rem"
                        }}>
                            <ul className={'list-group'} style={{
                                margin: '0',
                                fontSize: '1.2rem'
                            }}>
                                <li className={'list-group-item py-2'}>
                                    <b>Features &amp; Functionality</b>
                                </li>
                                <li className={'list-group-item py-2'}>
                                    Online Store &amp; In-house Inventory and Sales
                                </li>
                                <li className={'list-group-item py-2'}>
                                    Employee Calendar &amp; Time Entries
                                </li>
                                <li className={'list-group-item py-2'}>
                                    Member Tracking &amp; Outreach
                                </li>
                                <li className={'list-group-item py-2'}>
                                    Waivers &amp; Forms
                                </li>
                                <li className={'list-group-item py-2'}>
                                    Automated Tasks &amp; Billing
                                </li>
                                <li className={'list-group-item py-2'}>
                                    Robust Reports &amp; Insights
                                </li>
                                <li className={'list-group-item py-2'}>
                                    Gift Cards &amp; Invoices
                                </li>
                                <li className={'list-group-item py-2'}>
                                    Integrated Customer Portal
                                </li>
                                <li className={'list-group-item'}>
                                    and more...
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </Section>
            <section id="easy" className={"py-5"} style={{
                background: '#2c2c2c',
            }}>
                <div className="container">

                    <div className={"row"}>
                        <div className={"col-md-6"}>
                            <Typography variant="h4" className="mb-4 left fw-bold" color="white">Easy For Your
                                Customers</Typography>
                            <Typography variant="h5" className="mb-4 text-left" color="white">Easy to Use Branded
                                Customer Portal</Typography>
                            <h6 style={{
                                textAlign: 'left',
                                color: "#fff"
                            }}>Customer portal with easy to find classes and events. Customers can search for events by
                                date, time, activity, and ages.</h6>
                        </div>
                        <div className={"col-md-6"} style={{
                            position: 'relative',
                            maxWidth: '100%'
                        }}>
                            <img src="https://playspacebrain.com/images/psb-feature-6.png"
                                 alt="Play Space Brain Branded Cutsomer Portal"
                                 className="img-fluid rounded shadow" style={{
                                position: 'relative',
                                width: '80%',
                                zIndex: 1
                            }}/>
                            <img src="https://playspacebrain.com/images/psb-feature-4.png"
                                 alt="Play Space Brain Branded Customer Cart"
                                 className="img-fluid rounded shadow"
                                 style={{
                                     width: '65%',
                                     height: 'auto',
                                     position: 'absolute',
                                     zIndex: 2,
                                     top: '50px',
                                     left: '45%',
                                     boxShadow: 'rgb(17, 17, 17) 0px 0px 15px'
                                 }}
                            />
                            <img src="https://playspacebrain.com/images/psb-feature-5.png"
                                 alt="Play Space Brain Branded Class Registration"
                                 className="img-fluid rounded shadow img img-raised rounded img-comments rellax"
                                 style={{
                                     width: '45%',
                                     height: 'auto',
                                     position: 'absolute',
                                     zIndex: 2,
                                     top: '175px',
                                     left: '-15%',
                                     boxShadow: 'rgb(17, 17, 17) 0px 0px 15px'
                                 }}
                            />
                        </div>

                    </div>
                </div>
            </section>
            <div style={{
                background: '#efefef',
                borderTop: 'solid 1px #ccc',
                borderBottom: 'solid 1px #ccc'
            }}>
                <Section id="explore" bg={'grey'} title="Explore the Software">
                    <div className="row text-center">
                        <h5 className={'text-center'}>From booking to client management, get a visual preview of the
                            tools designed to simplify your day-to-day operations</h5>
                    </div>
                    <div className={'row'}>
                        <div className="col-md-4 mb-4">
                            <div className="bg-white p-4 rounded shadow-sm h-100">
                                <h5>Company Customization</h5>
                                <p className="text-muted">Configure the software to fit your unique play space</p>
                                <img
                                    style={{
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                        setImageUrl('https://playspacebrain.com/images/psb-feature-12.png');
                                        setImageTitle("Company Customization");
                                        setImageDesc("Lorem ipsum dolor sit amet consectetur adipiscing");
                                        setPreviewImage(true);
                                    }}
                                    src="https://playspacebrain.com/images/psb-feature-12.png" alt="About"
                                    className="img-fluid rounded shadow"/>
                            </div>
                        </div>

                        <div className="col-md-4 mb-4">
                            <div className="bg-white p-4 rounded shadow-sm h-100">
                                <h5>Customer Management &amp; CRM</h5>
                                <p className="text-muted">Make every customer feel seen, known, and appreciated through
                                    remembering the details.</p>
                                <img style={{
                                    cursor: 'pointer'
                                }}
                                     onClick={() => {
                                         setImageUrl('https://playspacebrain.com/images/psb-feature-11.png');
                                         setImageTitle("Customer Management & CRM");
                                         setImageDesc("Lorem ipsum dolor sit amet consectetur adipiscing");
                                         setPreviewImage(true);
                                     }}
                                     src="https://playspacebrain.com/images/psb-feature-11.png" alt="About"
                                     className="img-fluid rounded shadow"/>
                            </div>
                        </div>

                        <div className="col-md-4 mb-4">
                            <div className="bg-white p-4 rounded shadow-sm h-100">
                                <h5>Waivers &amp; Forms</h5>
                                <p className="text-muted">Keep every waiver and contract organized and attached to the
                                    customers profile.
                                </p>
                                <img style={{
                                    cursor: 'pointer'
                                }}
                                     onClick={() => {
                                         setImageUrl('https://playspacebrain.com/images/psb-feature-10.png');
                                         setImageTitle("Waivers & Forms");
                                         setImageDesc("Lorem ipsum dolor sit amet consectetur adipiscing");
                                         setPreviewImage(true);
                                     }}
                                     src="https://playspacebrain.com/images/psb-feature-10.png" alt="About"
                                     className="img-fluid rounded shadow"/>
                            </div>
                        </div>
                        <div className="col-md-4 mb-4">
                            <div className="bg-white p-4 rounded shadow-sm h-100">
                                <h5>Memberships</h5>
                                <p className="text-muted">Recurring memberships, camps, sessions. multi and single day
                                    passes, with sibling rates and family pass options.
                                </p>
                                <img style={{
                                    cursor: 'pointer'
                                }}
                                     onClick={() => {
                                         setImageUrl('https://playspacebrain.com/images/psb-feature-9.png');
                                         setImageTitle("Memberships");
                                         setImageDesc("Lorem ipsum dolor sit amet consectetur adipiscing");
                                         setPreviewImage(true);
                                     }}
                                     src="https://playspacebrain.com/images/psb-feature-9.png" alt="About"
                                     className="img-fluid rounded shadow"/>
                            </div>
                        </div>

                        <div className="col-md-4 mb-4">
                            <div className="bg-white p-4 rounded shadow-sm h-100">
                                <h5>Calendar &amp; Events</h5>
                                <p className="text-muted">Customize your calendar to fit all of your events from
                                    birthday parties, special events, workshops, open play, recurring classes, sessions,
                                    camps, general public and member only events.
                                </p>
                                <img
                                    style={{
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                        setImageUrl('https://playspacebrain.com/images/psb-feature-8.png');
                                        setImageTitle("Calendar & Events");
                                        setImageDesc("Lorem ipsum dolor sit amet consectetur adipiscing");
                                        setPreviewImage(true);
                                    }}
                                    src="https://playspacebrain.com/images/psb-feature-8.png" alt="About"
                                    className="img-fluid rounded shadow"/>
                            </div>
                        </div>

                        <div className="col-md-4 mb-4">
                            <div className="bg-white p-4 rounded shadow-sm h-100">
                                <h5>Inventory Management</h5>
                                <p className="text-muted">Keep track of all of your inventory, sell in person and
                                    online.</p>
                                <img
                                    style={{
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                        setImageUrl('https://playspacebrain.com/images/psb-feature-7.png');
                                        setImageTitle("Inventory Management");
                                        setImageDesc("Lorem ipsum dolor sit amet consectetur adipiscing");
                                        setPreviewImage(true);
                                    }}
                                    src="https://playspacebrain.com/images/psb-feature-7.png" alt="About"
                                    className="img-fluid rounded shadow"/>
                            </div>
                        </div>
                    </div>
                </Section>
            </div>


            <Section id="features" bg="white" title="A Full Set of Resources to Streamline Your Play Space">
                <div className="container" style={{
                    zIndex: '25'
                }}>
                    <div className="row">
                        <div className="col-md-12 col-lg-12">

                            <div className="row">
                                <div className="pt-5 col-md-3">
                                    <div className="card-pricing card-background card">
                                        <div className="card-body"><h3 className="card-title">Scheduling</h3>
                                            <ul>
                                                <li>Drop In Play</li>
                                                <li>Single Class Event</li>
                                                <li>Special Events</li>
                                                <li>Birthday Parties</li>
                                                <li>Party Add Ons</li>
                                                <li>Multiple Locations</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="pt-5 col-md-3">
                                    <div className="card-pricing card-background card">
                                        <div className="card-body"><h3 className="card-title">Client / Customer
                                            Management</h3>
                                            <ul>
                                                <li>In Depth Family Profiles</li>
                                                <li>Waivers</li>
                                                <li>Tags</li>
                                                <li>Recurring Memberships</li>
                                                <li>Class Packs</li>
                                                <li style={{
                                                    display: showMore ? 'block' : 'none'
                                                }}>Single Day Passes
                                                </li>

                                                <li style={{
                                                    display: showMore ? 'block' : 'none'
                                                }}>Client Tracking
                                                </li>
                                                <li style={{
                                                    display: showMore ? 'block' : 'none'
                                                }}>Client History
                                                </li>
                                                <li style={{
                                                    display: showMore ? 'block' : 'none'
                                                }}>Notes
                                                </li>
                                                <li style={{
                                                    display: showMore ? 'block' : 'none'
                                                }}>Branded Client Portal to Self Manage Memberships and Schedule
                                                </li>
                                                <li style={{
                                                    display: showMore ? 'block' : 'none'
                                                }}>Rebook / Cancel
                                                </li>

                                                <li style={{
                                                    display: showMore ? 'block' : 'none'
                                                }}>Class Wait Lists
                                                </li>

                                                <li style={{
                                                    display: showMore ? 'block' : 'none'
                                                }}>Full Site Search Bar
                                                </li>

                                                <li style={{
                                                    cursor: 'pointer',
                                                    textDecoration: 'underline'
                                                }} onClick={() => {
                                                    setShowMore(!showMore)
                                                }}>And More...
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="pt-5 col-md-3">
                                    <div className="card-pricing card-background card"
                                         style={{
                                             background: 'rgb(213, 220, 246)',
                                             zIndex: '999'
                                         }}>
                                        <div className="card-body"><h3 className="card-title">Calendar</h3>
                                            <ul>
                                                <li>Website Integrated Events Calendar</li>
                                                <li>Mobile Friendly</li>
                                                <li>Search by Time, Age, Activity, Instructor</li>
                                                <li>Private Event Bookings and Add Ons</li>
                                                <li>Party Add Ons</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="pt-5 col-md-3">
                                    <div className="card-pricing card-background card"
                                    >
                                        <div className="card-body"><h3 className="card-title">Reports</h3>
                                            <ul>
                                                <li>Revenue</li>
                                                <li>Client Insights</li>
                                                <li>Referrals</li>
                                                <li>Parties &amp; Events</li>
                                                <li>Tags</li>
                                                <li>Invoice</li>


                                                <li style={{
                                                    display: showMoreReports ? 'block' : 'none'
                                                }}>Active Customers
                                                </li>
                                                <li style={{
                                                    display: showMoreReports ? 'block' : 'none'
                                                }}>Next Contact Customers
                                                </li>
                                                <li style={{
                                                    display: showMoreReports ? 'block' : 'none'
                                                }}>New Customers
                                                </li>
                                                <li style={{
                                                    display: showMoreReports ? 'block' : 'none'
                                                }}>Active Memberships
                                                </li>
                                                <li style={{
                                                    display: showMoreReports ? 'block' : 'none'
                                                }}>Daily Visits
                                                </li>


                                                <li style={{
                                                    cursor: 'pointer',
                                                    textDecoration: 'underline'
                                                }} onClick={() => {
                                                    setShowMoreReports(!showMoreReports)
                                                }}>And More...
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="pt-5 col-md-3">
                                    <div className="card-pricing card-background card"
                                    >
                                        <div className="card-body"><h3 className="card-title">Lead Management and
                                            Retention</h3>
                                            <ul>
                                                <li>Contact and Retain New Customers</li>
                                                <li>Email list integration</li>
                                                <li>Smart Contact List (by age, tags, previous classes)</li>
                                                <li>Custom Communication Templates</li>
                                                <li>Automatic Notifications for Client and Business Owner</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="pt-5 col-md-3">
                                    <div className="card-pricing card-background card"
                                    >
                                        <div className="card-body"><h3 className="card-title">Staff Management</h3>
                                            <ul>
                                                <li>Time Clock</li>
                                                <li>Staff Profiles</li>
                                                <li>Payroll Reports</li>
                                                <li>To Do Lists</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="pt-5 col-md-3">
                                    <Card className="card-pricing card-background card"
                                          style={{
                                              background: 'rgb(213, 220, 246)',
                                              zIndex: '999'
                                          }}>
                                        <div className="card-body"><h3 className="card-title">Inventory</h3>
                                            <ul>
                                                <li>Sell Products In Store &amp; Online</li>
                                                <li>Inventory Categories</li>
                                                <li>Customize Coupons, Discounts, and Promotions</li>
                                                <li>Stripe Integration</li>
                                                <li>Square Integration</li>
                                            </ul>
                                        </div>
                                    </Card>
                                </div>

                                <div className="pt-5 col-md-3">
                                    <Card className="card-pricing card-background card"
                                          style={{
                                              background: 'rgb(213, 220, 246)',
                                              zIndex: '999'
                                          }}>
                                        <div className="card-body"><h3
                                            className="card-title">Apps &amp; Integrations</h3>
                                            <ul>
                                                <li>Stripe</li>
                                                <li>Square</li>
                                                <li>Clover (coming soon)</li>
                                                <li>Twilio for Texting</li>
                                                <li>Zapier</li>
                                            </ul>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </Section>

            <div style={{
                background: '#efefef',
                borderTop: 'solid 1px #ccc',
                borderBottom: 'solid 1px #ccc',
                display: 'block'
            }}>
                <Section id="pricing" bg="efefef" title="Pricing"
                         subtitle="Limited spots available for our early access program">
                    <div className="row">
                        <div className={'col-md-3 text-center'}>
                        </div>
                        <div className={'col-md-6 text-center'}>
                            <div className="card-pricing card-background card card-ltd col-md-6">
                                <ul>
                                    <li>No Sign Up Fee</li>
                                    <li>One on One Personal Onboarding</li>
                                    <li>1 Month Free Trial - No Commitment</li>
                                    <li>
                                        <b>$279</b> / Month
                                    </li>
                                    <li>
                                        Full Access to All Tools
                                    </li>
                                    <li>Dedicated Support</li>
                                    <li>Opportunities to Test New Features</li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </Section>
            </div>

            <div id="contact" style={{
                background: '#2c446e',
            }}>
                <div className="row px-5">
                    <div className="pt-5 col-md-3">
                    </div>
                    <div className="pt-5 col-md-6">
                        <h3 style={{
                            color: '#fff',
                            fontWeight: 'bold'
                        }}>Your voice matters, Pilot Users help guide our next features and
                            future!</h3>

                        <p style={{
                            color: '#fff',
                            fontWeight: 'bold'
                        }}>Want to watch videos on your own time? Sign up and we will send you
                            access to
                            demo videos. <br/>
                            <a href={'#'} onClick={() => {
                                setShowFormModal(true);
                            }}>Ready for a live demo sign up here</a>.
                        </p>

                        <div className={'text-center'}>
                            <Button variant="contained" color="primary" size="large" className="mt-3"
                                    onClick={() => {
                                        setShowFormModal(true);
                                    }}>
                                Contact Us to Join
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={previewImage}
                   onHide={() => {
                       setPreviewImage(false);
                   }} size={'xl'}>
                <Modal.Header closeButton>
                    <Modal.Title>{imageTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <img src={imageUrl} alt="About"
                         className="img-fluid rounded shadow"/>
                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </Modal>

            <Modal show={showFormModal}
                   onHide={() => {
                       setFormResponse(null);
                       setSubmitting(false);
                       setShowFormModal(false);
                   }} size={'lg'}>
                <Modal.Header closeButton>
                    <Modal.Title>Thank you for your interest!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formResponse && <p className={'text-center'}>{formResponse}</p>}

                    {!formResponse && <form name="contactForm" onSubmit={handleSubmit}>
                        <Row className={'mb-2'}>
                            <Col md={6}>
                                <input type="password" style={{
                                    position: 'absolute',
                                    top: '20px',
                                    left: '-999em'
                                }} id={"psbRef"} name={"psbRef"}
                                       autoComplete="off"
                                       onChange={(e) => {
                                           setPsbRef(e.target.value);
                                       }}
                                />
                                <label htmlFor={'name'}>Name</label><br/>
                                <OutlinedInput name={"name"}
                                               required
                                               onChange={(e) => {
                                                   setName(e.target.value)
                                               }} id={"name"}
                                               className={'w-100'}
                                               placeholder={"Your Name"}
                                               type={'text'}/>
                            </Col>
                            <Col md={6}>
                                <label htmlFor={'email'}>Email</label><br/>
                                <OutlinedInput required
                                               onChange={(e) => {
                                                   setEmail(e.target.value)
                                               }} id={"email"}
                                               name={"email"} className={'w-100'}
                                               placeholder={"Email"}
                                               type={'email'}/>
                            </Col>
                        </Row>
                        <Row className={'mb-2'}>
                            <Col md={6}>
                                <label htmlFor={'phone'}>Phone</label><br/>
                                <OutlinedInput
                                    onChange={(e) => {
                                        setPhone(e.target.value)
                                    }} id={"phone"}
                                    name={"phone"} className={'w-100'}
                                    placeholder={"Phone"}
                                    type={'text'}/>
                            </Col>
                            <Col md={6}>
                                <label htmlFor={'website'}>Website</label><br/>
                                <OutlinedInput onChange={(e) => {
                                    setWebsite(e.target.value)
                                }}
                                               name={"website"} id={"website"} className={'w-100'}
                                               placeholder={"Website"}
                                               type={'text'}/>
                            </Col>
                        </Row>

                        <Row className={'mb-2'}>
                            <Col md={6}>
                                <label htmlFor={'softwares'}>List any software you are currently using
                                    (optional)</label><br/>
                                <OutlinedInput
                                    onChange={(e) => {
                                        setSoftwares(e.target.value)
                                    }} id={"softwares"}
                                    name={"softwares"} className={'w-100'}
                                    placeholder={"Additional Softwares"}
                                    type={'text'}/>
                            </Col>
                            <Col md={6}>
                                <label>Best time to reach you?</label><br/>
                                <OutlinedInput onChange={(e) => {
                                    setContactTime(e.target.value)
                                }} id={"contactTime"}
                                               name={"contactTime"} className={'w-100'}
                                               placeholder={"10:15am - 3:30pm (Mon-Fri)"}
                                               type={'text'}/>
                            </Col>
                        </Row>
                        <Row className={'mb-2'}>
                            <Col md={12} className={'text-right'}>
                                <Button variant="contained"
                                        disabled={submitting}
                                        color="primary" size="large" className="mt-3"
                                        type="submit">
                                    {submitting ? 'Sending...' : 'Send'}
                                </Button>
                            </Col>
                        </Row>
                    </form>
                    }
                </Modal.Body>
                <Modal.Footer>
                    {!formResponse &&
                        <p>We will do our best to reach out to you at your preferred time. Please look for an email
                            reply
                            shortly after submitting inquiry.</p>}
                </Modal.Footer>
            </Modal>

        </>
    );
};

export default Home;
